module.exports = __webpack_public_path__ + "img/appDown.0a1a3176.png";